import { connect } from 'react-redux'
import { actions, jsonApiWrapper } from '@opallabs/wormhole'
import MomentAssetPicker from '.'

const deserializeMoment = (id, state) => {
  const momentData = jsonApiWrapper({
    data: state.jsonApiEntities.moment[id],
    state,
  })
  return {
    ...momentData,
    preview: {
      url: momentData.primary_asset_reference.preview_url,
    },
  }
}

const mapStateToProps = (state, ownProps) => ({
  moment: deserializeMoment(ownProps.momentId, state),
})

const mapDispatchToProps = (dispatch) => ({
  onSaveAsset: ({ moment, selectedAssetId, selectedAssetUrl }) =>
    dispatch(
      actions.updateMoment({
        momentId: moment.id,
        update: {
          primary_asset_reference_id: selectedAssetId,
          previewUrl: selectedAssetUrl,
        },
      })
    ),
  uploadAsset: (params) => dispatch(actions.handleAssetUploadV2(params)),
})

const ConnectedMomentAssetPicker = connect(
  mapStateToProps,
  mapDispatchToProps
)(MomentAssetPicker)

export default ConnectedMomentAssetPicker
